import Link from "next/link";

import cn from "classnames";

import type { GetNavigationQueryResult } from "@/sanity.types";

import {
  hasNavigationLink,
  isNavigationMenuGroupItem,
} from "./navigationQuery.types";

export const HeaderMobileSecurityMenu = ({
  menu,
}: HeaderMobileSecurityMenuProps) => {
  const renderNav = () => {
    if (!menu?.items?.length) return null;
    return menu.items.map((nav) => {
      if (isNavigationMenuGroupItem(nav)) return null;
      if (!hasNavigationLink(nav) || !nav.link.url) return null;
      const target = nav.link.openInNewTab ? "_blank" : "_self";
      return (
        <li
          data-testid="header-mobile-security-menu-list-item"
          key={nav.label}
          className="hover:bg-secondary-100 flex duration-500">
          <Link
            className={cn("w-full px-4 py-4 whitespace-nowrap normal-case")}
            href={{
              pathname: nav.link.url,
              query: nav.link.queryString,
            }}
            target={target}>
            {nav.label}
          </Link>
        </li>
      );
    });
  };
  return (
    <menu
      id="header-mobile-security-menu"
      popover="auto"
      data-testid="header-mobile-security-menu"
      className="group top-18.5 h-full w-90 bg-black/50 text-white"
      aria-label={`${menu?.label || "Security"} menu`}>
      <nav id="header-mobile-security-menu-nav" className="bg-secondary pt-6">
        <ul
          data-testid="header-mobile-security-menu-list"
          className="flex flex-col">
          {renderNav()}
        </ul>
      </nav>
    </menu>
  );
};

export type HeaderMobileSecurityMenuProps = {
  menu?: GetNavigationQueryResult;
};
